import {
    Depot,
    eachArray,
    Instance,
    Objekt,
    Promize,
    Query,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { GoogleChartService } from '@services/googleChartService';
import { LanguageService } from '@services/languageService';
import { ReportService } from '@services/reportService';
import { DashboardController } from './dashboardController';

export class ReportsPeopleWhenShootController extends DashboardController {
    static readonly inject = [
        'instances',
        'reportService',
        'googleChartService',
        'languageService',
    ] as const;

    localDepot: Depot;
    chart!: google.visualization.ColumnChart;

    constructor(
        instances: Instance,
        private reportService: ReportService,
        private googleChartService: GoogleChartService,
        private languageService: LanguageService,
    ) {
        super(instances);

        this.localDepot = instances.localDepot;
    }

    protected override _initLayout(): void {
        this._initToolbarButtons();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initChart();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton('.btn-reports-index', this.dom, () => {
            this.state.goBack('reports.index');
        });

        this.helper.fabButton('.btn-reports-filter', this.dom, () => {
            this.reportService.detailsDialog('people');
        });
    }

    private _initChart(): void {
        if (!this.chart) {
            this.googleChartService.loadSDK(['corechart', 'bar']).then(() => {
                const chartKnot = new Query('.chart', this.dom).getKnot();

                this.chart = new google.visualization.ColumnChart(
                    chartKnot.getNode(),
                );
                const chartOptions: google.visualization.ColumnChartOptions = {
                    // width: '100%',
                    height: 460,
                    legend: { position: 'bottom' },
                    colors: ['#795548', '#FF9800'],
                };

                const peopleReport = new Objekt(
                    this.localDepot.get(
                        this.reportService.getStorageKeyReport('people'),
                    ),
                );
                this.reportService
                    .getAllByPeople(
                        peopleReport,
                        new Objekt({
                            fields: 'id,killing_at,count,count_prev',
                        }),
                    )
                    .then((response) => {
                        const objects = response.get<Objekt[]>('objects');

                        const data = new google.visualization.DataTable();
                        data.addColumn('string', '');
                        data.addColumn(
                            'number',
                            this.languageService.translate(
                                'captions.trophies.prev_index',
                            ),
                        );
                        data.addColumn(
                            'number',
                            this.languageService.translate(
                                'captions.trophies.index',
                            ),
                        );
                        eachArray(objects, (object) => {
                            data.addRow([
                                object.get<string>('killing_at'),
                                object.get<number>('count_prev'),
                                object.get<number>('count'),
                            ]);
                        });
                        this.chart.draw(data, chartOptions);
                    });
            });
        }
    }

    exit(): void {
        super.exit();

        this.googleChartService.reset();
    }
}

export const reportsPeopleWhenShootController = app.controller(
    'reportsPeopleWhenShootController',
    ReportsPeopleWhenShootController,
);
